import React from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { form } from "../forms";
import NonFieldErrors from "../forms/components/NonFieldErrors";
import RiskScoreSlider from "../forms/components/RiskScoreSlider";
import { FieldWidget as Widget } from "../forms/components/Widget";
import ThreatName from "../forms/components/ThreatName";

const UserClassificationForm = ({
  onSubmit,
  onCancel,
  onRemove,
  onChange,
  values,
  initial,
  isUserClassified,
  userClassificationType,
  key
}) => {
  const idRoot = `set-classification--${userClassificationType}`;
  const riskScoreMinMax =
    values.threat_status === "goodware" || values.threat_status === "unknown"
      ? { min: 0, max: 5 }
      : { min: 6, max: 10 };

  return (
    <Form
      id={idRoot}
      className="user-classification-form"
      onSubmit={e => {
        e.preventDefault();
        onSubmit();
      }}
      key={key}
      noValidate
    >
      <NonFieldErrors />
      <Form.Group as={Row}>
        <Col xs={7}>
          <Widget
            id={`${idRoot}--classification`}
            name="threat_status"
            label="Classification"
            labelBold
            as={Form.Select}
            className="set-classification-input"
            vertical
            marginBottom={15}
          >
            {initial.threat_status === "unknown" && (
              <option key="unknown" value="unknown" disabled>
                -- Select Classification --
              </option>
            )}
            <option
              id={`${idRoot}--classification--goodware-item`}
              key="goodware"
              value="goodware"
            >
              Goodware
            </option>
            <option
              id={`${idRoot}--classification--suspicious-item`}
              key="suspicious"
              value="suspicious"
            >
              Suspicious
            </option>
            <option
              id={`${idRoot}--classification--malicious-item`}
              key="malicious"
              value="malicious"
            >
              Malicious
            </option>
          </Widget>
        </Col>
        <Col xs={5}>
          <Widget
            id={`${idRoot}--risk-score`}
            label="Risk Score"
            labelBold
            classification={values.threat_status}
            min={0}
            max={10}
            permittedValues={riskScoreMinMax}
            step={1}
            name="factor"
            as={RiskScoreSlider}
            value={values.factor}
            vertical
            marginBottom={15}
          />
        </Col>
      </Form.Group>
      {(values.threat_status === "suspicious" ||
        values.threat_status === "malicious") && (
        <Form.Group>
          <Widget
            id={`${idRoot}--threat-name`}
            label="Threat Name"
            labelBold
            name="threat_name"
            as={ThreatName}
            onChange={onChange}
            vertical
          />
        </Form.Group>
      )}
      <Form.Group>
        <Col xs={12}>
          <ButtonToolbar className="btn-toolbar--separator">
            <div className="pull-right">
              {isUserClassified && (
                <Button
                  id={`${idRoot}--remove-classification-btn`}
                  type="button"
                  variant="prompt-secondary"
                  onClick={onRemove}
                  className="pull-left"
                >
                  Remove Classification
                </Button>
              )}
              <Button
                id={`${idRoot}--cancel-btn`}
                type="button"
                variant="prompt-secondary"
                onClick={onCancel}
              >
                Cancel
              </Button>
              <Button
                id={`${idRoot}--save-btn`}
                type="submit"
                variant="prompt-primary"
              >
                Save
              </Button>
            </div>
          </ButtonToolbar>
        </Col>
      </Form.Group>
    </Form>
  );
};

UserClassificationForm.propTypes = {
  values: PropTypes.shape({
    threatStatus: PropTypes.string,
    factor: PropTypes.number,
    threat_status: PropTypes.string,
    platform: PropTypes.string,
    type: PropTypes.string,
    family: PropTypes.string
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
  isUserClassified: PropTypes.bool,
  userClassificationType: PropTypes.string
};

export default form(UserClassificationForm);
